import React from 'react';
import styles from './styles.scss';

const CoverImage = () => <div id="cover-image" className={styles.cover} />;

export default CoverImage;
